import {i18n} from "../plugins/language/index";
export default [
    {
        index:0,
        icon_new: 'face-id-new',
        icon: 'face-id',
        value:'l.face'
    },
    {
        index:1,
        icon: 'video',
        icon_new: 'video-new',
        value: 'l.video_monitor'
    },
    {
        index:2,
        icon_new: 'mobile-control-new',
        icon: 'mobile-control',
        value: 'l.scan_lift'
    },
    {
        index:3,
        icon_new: 'multi-talk-new',
        icon: 'multi-talk',
        value: 'l.video_call'
    },
    {
        index:4,
        icon_new: 'onekey-help-new',
        icon: 'onekey-help',
        value: 'l.click_help'
    },
    {
        index:5,
        icon: 'adv',
        icon_new: 'adv_new',
        value: 'l.video_ad'
    },

]